"use client";
import React, { useEffect, useState } from "react";
import { useTranslations } from "next-intl";
import { ReztoLogo } from "@assets/icons";
import QwertyLogo from "@assets/icons/qwerty.svg";
import InstagramIcon from "@assets/icons/instagram.svg";
import FacebookIcon from "@assets/icons/facebook.svg";
import PhoneIcon from "@assets/icons/phone.svg";
import EmailIcon from "@assets/icons/email.svg";
import { convertToMtavruli } from "@utils/sync/GeneralUtils";

const Footer = () => {
  const g = useTranslations("General");
  const [deviceType, setDeviceType] = useState<any>(null);

  useEffect(() => {
    const userAgent =
      navigator?.userAgent || navigator?.vendor || window?.opera;

    if (/android/i.test(userAgent)) {
      setDeviceType("android");
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window?.MSStream) {
      setDeviceType("ios");
    } else {
      setDeviceType("other");
    }
  }, []);

  const dynamicMargin = deviceType === "ios" ? "mt-20" : "mt-[-15px]";

  return (
    <footer
      className={`z-[2] mx-auto flex w-[90%] flex-col gap-6 bg-white p-0 pb-4 pt-[20px] sm:py-8 sm:pb-0 lg:pb-[38px] lg:pt-[52px] f${dynamicMargin}`}
    >
      <div className="flex flex-col items-start justify-between gap-6 lg:flex-row lg:items-center">
        <div className="flex w-full flex-row items-center justify-between gap-4 lg:w-auto">
          <ReztoLogo />
          <div className="w-full max-w-64 lg:max-w-[385px]">
            <p className="break-words text-start text-xs text-[#6C6C6C] sm:text-left sm:text-base">
              {g("addYourRestaurant")}
            </p>
          </div>
        </div>
        <div className="flex w-full flex-row-reverse justify-between lg:w-auto lg:flex-row lg:gap-[30px]">
          {/* social media start */}
          <div className="flex flex-col gap-4">
            <h4 className="text-xs font-medium text-black md:text-base">
              {convertToMtavruli(g("socialMedia"))}
            </h4>
            <div className="flex flex-row gap-4">
              <div className="flex items-center gap-2">
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#F7F4F8]">
                  <a
                    href="https://www.facebook.com/reztoge"
                    target="_blank"
                    rel="noopener"
                    className="text-sm sm:text-base"
                  >
                    <FacebookIcon />
                  </a>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#F7F4F8]">
                  <a
                    href="https://www.instagram.com/reztoge/"
                    target="_blank"
                    rel="noopener"
                    className="text-sm sm:text-base"
                  >
                    <InstagramIcon />
                  </a>
                </div>
              </div>
            </div>
          </div>
          {/* social media end */}
          <div className="hidden h-20 !w-[1px] bg-neutral-100 lg:block" />
          {/* contact start */}
          <div className="flex flex-col gap-4">
            <h4 className="text-xs font-medium text-black md:text-base">
              {convertToMtavruli(g("contact"))}
            </h4>
            <div className="flex flex-col gap-4 sm:flex-row">
              <div className="flex items-center gap-2">
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#F7F4F8]">
                  <PhoneIcon />
                </div>
                <a href="tel:0322888222" className="text-sm sm:text-base">
                  2 888 222
                </a>
              </div>
              <div className="flex items-center gap-2">
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#F7F4F8]">
                  <EmailIcon />
                </div>
                <a href="mailto:info@rezto.ge" className="text-sm sm:text-base">
                  info@rezto.ge
                </a>
              </div>
            </div>
          </div>
          {/* contact end */}
        </div>
      </div>
      <div className="h-[1px] w-full bg-neutral-100" />
      <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
        <div className="flex items-center gap-2">
          <h1 className="text-sm text-[#1A1D1FB2] sm:text-base">
            {g("poweredBy")}
          </h1>
          <QwertyLogo className="mt-1" />
        </div>
        <p className="text-center text-sm text-[#666666] sm:text-base">
          {`${new Date().getFullYear()} ${g("allRightsReserved")} `}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
